export default {
  state: {
    search: "",
    filter: {}
  },
  mutations: {
    dosearch: (state, value) => {
      state.search = value;
    },
    clearsearch: state => {
      state.search = "";
    },
    dofilter: (state, data) => {
      if(data.key in state.filter && data.value == state.filter[data.key]) {
        delete state.filter[data.key]
        state.filter = { ...state.filter, ...{}}
      } else {
        state.filter = { ...state.filter, ...{[data.key]: data.value} }
      }
    },
    clearFilter: state => {
      state.filter = {}
    }
  },
  getters: {
    searchstring: ({ search }) => search,
    filter: ({filter}) => filter
  }
};
